import axios from "axios";
import { format, formatDistanceToNowStrict } from "date-fns";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${x.msg}`).join(", ");
  if (d?.message) return d.message;
  return e?.message || "Something went wrong";
};

const toDate = (s) => new Date(s.length === 10 ? `${s}T00:00:00` : s);
export const fmtDate = (s) => (s ? format(toDate(s), "d MMM yyyy") : "—");
export const fmtShort = (s) => (s ? format(toDate(s), "d MMM") : "—");
export const fmtDateTime = (s) => (s ? format(toDate(s), "d MMM yyyy, h:mm a") : "—");
export const fromNow = (s) => (s ? formatDistanceToNowStrict(toDate(s), { addSuffix: true }) : "—");
export const todayISO = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
export const addDaysISO = (n) => {
  const d = new Date(`${todayISO()}T00:00:00`);
  d.setDate(d.getDate() + n);
  return d.toLocaleDateString("en-CA");
};
export const initials = (n = "") => n.split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
export const fmtCompactINR = (v) => {
  const n = Number(v) || 0;
  if (n >= 1e7) return `₹${+(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${+(n / 1e5).toFixed(1)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const downloadFile = async (url, filename, params) => {
  const r = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
};
